import * as React from "react";
import { observer } from "mobx-react";
import { AuthenticationState } from "bernie-context";
import { TripAttachQualificationProps } from "./typings";
import { TripAttachQualificationView } from "./TripAttachQualificationView";
import { TripAttachLoadingView } from "./components/TripAttachLoadingView";
import { withStores } from "stores";

export enum TripAttachQualificationMipType {
  HOTMIP = "HOTMIP",
  CARMIP = "CARMIP",
}

export const TripAttachQualification = withStores(
  "compositionStore",
  "flexViewModel"
)(
  observer((props: TripAttachQualificationProps) => {
    if (!props.compositionStore) {
      return null;
    }

    if (props.flexViewModel.flexContext.userContext.userType !== AuthenticationState.AUTHENTICATED) {
      return null;
    }

    const [isLoading, setLoading] = React.useState(true);

    React.useEffect(() => {
      if (props.compositionStore) {
        props.compositionStore
          .updateModule({ fmId: flexComponent.fmId })
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }, []);

    const { flexComponent } = props;
    if (
      !(
        flexComponent.model &&
        flexComponent.model.destinationName &&
        flexComponent.model.tripStartDate &&
        flexComponent.model.tripEndDate &&
        flexComponent.model.deepLink &&
        flexComponent.model.deepLinkMipType &&
        flexComponent.model.percentageOff
      )
    ) {
      return isLoading ? <TripAttachLoadingView /> : null;
    }

    return (
      <TripAttachQualificationView
        deepLink={flexComponent.model.deepLink}
        deepLinkMipType={flexComponent.model.deepLinkMipType}
        destinationName={flexComponent.model.destinationName}
        imageData={flexComponent.model.imageData}
        moduleName={flexComponent.name}
        percentageOff={flexComponent.model.percentageOff}
        tripEndDate={flexComponent.model.tripEndDate}
        tripStartDate={flexComponent.model.tripStartDate}
      />
    );
  })
);

export default TripAttachQualification;
